import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'OrganizedUnit/LegalCompany', method: 'POST', body: body, token: token })
}
